import template from './toggleSwitch.html';
import controller from './toggleSwitch.controller';
import './toggleSwitch.scss';

let toggleSwitchComponent = {
  restrict: 'E',
  bindings: {
    enabled: '<',
    onChange: '&',
    label: '@',
    disabled: '@',
    isMobileApp: '<'
  },
  template,
  controller
};

export default toggleSwitchComponent;



// WEBPACK FOOTER //
// ./client/app/components/toggleSwitch/toggleSwitch.component.js